var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { key: _vm.uniq_ref, staticClass: "qr-wrapper" }, [
    _c("div", { staticClass: "qr-box" }),
    _vm._v(" "),
    _c("div", { staticClass: "flex" }, [
      _c(
        "button",
        {
          staticClass: "btn btn-sm btn-primary mt-2",
          on: { click: _vm.downloadQr },
        },
        [_vm._v(_vm._s(_vm.__t("DOWNLOAD")))]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn btn-sm btn-primary mt-2",
          on: { click: _vm.go_url },
        },
        [_vm._v(_vm._s(_vm.__t("GO_URL")))]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }